<template>
  <div>
    <!--     <M1Vue></M1Vue> -->
    <bannerVue
      v-if="bannerList.length > 0"
      :bannerList="bannerList"
    ></bannerVue>

    <!-- 流動版介面 (less than 768px) -->
    <div class="mobile">
      <section class="m-video section-block" v-if="featureList.length > 0">
        <div class="section-title">
           {{ $t('Index.SelectedFilms') }} <a href="/videoList" class="section-more">  {{ $t('Index.more') }} </a>
        </div>
        <div class="m-wrap-list">
          <ul class="m-list-wrapper">
            <li
              v-for="Featured in featureList"
              :key="Featured.id"
              class="m-list-item"
            >
              <router-link
                :title="Featured.sgL_Mov_VSubject"
                class="items-center"
                :to="{
                  path: `/videowatch/${Featured.sgL_Mov_Vid}/video`,
                }"
              >
                <div class="m-thumbnail">
                  <div class="m-responsive">
                    <div class="m-sizer">
                      <div
                        class="m-image"
                        :style="{
                          backgroundImage:
                            'url(' + `${Featured.imageFileP}` + ')',
                        }"
                      ></div>
                    </div>
                  </div>
                  <div class="video-duration">
                    <span>{{ Featured.mov_VSourceTimeFormat }}</span>
                  </div>
                </div>
                <div class="video-info">
                  <span class="video-title">
                    {{ Featured.sgL_Mov_VSubject }}
                  </span>
                </div>
              </router-link>
            </li>
          </ul>
        </div>
      </section>
      <section
        class="m-video section-block"
        v-if="CloudList.length > 0"
      >
        <h2 class="section-title">
           {{ $t('Index.FeedCloud') }}
          <a href="/feed/FeedCloud" class="section-more">  {{ $t('Index.more') }} </a>
        </h2>
        <div class="row">
          <div class="pool-fm row-cols-1 row-cols-sm-1 row-cols-md-3 g-3">
            <singleVideoVue
              v-for="item in CloudList"
              :key="item.id"
              :id="item.id"
              :url="item.fileShareUrl"
              :avatar="item.userLogoBig"
              :authorName="item.sgL_MyVideoName"
              :displayName="item.sgL_UsersName"
              :date="item.sgL_PG_CAddTimerI"
              :lookCount="item.sgL_PG_CTotalView"
              :title="item.sgL_Title"
              :likeCount="item.sgL_PG_CTotalLike"
              :poster="item.sgL_ImageTempURL"
              :poster2="item.jietuFileUrl"
              :showViewData="false"
              :showDetail="false"
              :item="item"
              @like="likeFunc(item)"
              class="pool-cloud fm-set"
            >
              <template v-slot:SpecifyMenu>
                <moreMenuVue @ck="copyLink(item.id)">
                  <template v-slot:icon>
                    <i class="fa fa-clone mr-1"></i>
                  </template>
                  <template v-slot:txt>  {{ $t('Index.Copylinks') }} </template>
                </moreMenuVue>
                <moreMenuVue @ck="collectFunc(item)">
                  <template v-slot:icon>
                    <i
                      v-if="item.sgL_IsFavorite"
                      class="fas fa-bookmark fa-fw"
                    ></i>
                    <i v-else class="far fa-bookmark mr-1"></i>
                  </template>
                  <template v-slot:txt>  {{ $t('Index.bookmark') }} </template>
                </moreMenuVue>
                <moreMenuVue @ck="updateStatistics(item, 50)">
                  <template v-slot:icon>
                    <i class="fa fa-share mr-1"></i>
                  </template>
                  <template v-slot:txt>  {{ $t('Index.share') }} </template>
                </moreMenuVue>
                <moreMenuVue @ck="reportFunc(item)">
                  <template v-slot:icon>
                    <i class="far fa-flag mr-1"></i>
                  </template>
                  <template v-slot:txt>  {{ $t('Index.flag') }} </template>
                </moreMenuVue>
              </template>
            </singleVideoVue>
          </div>
        </div>
      </section>
      <section class="m-album section-block" v-if="albumHotList.length > 0">
        <div class="section-title">
           {{ $t('Index.albumHotList') }}<a href="/albumList" class="section-more">  {{ $t('Index.more') }} </a>
        </div>
        <div class="m-wrap-list">
          <ul class="m-list-wrapper">
            <li v-for="hot in albumHotList" :key="hot.id" class="m-list-item">
              <router-link
                :title="hot.sgL_PG_CName"
                class="items-center"
                :to="{
                  name: 'albumviewPhotostream',
                  query: { id: hot.id },
                }"
              >
                <div class="m-thumbnail">
                  <div class="m-responsive">
                    <div class="album-sizer">
                      <div
                        class="m-image"
                        :style="{
                          backgroundImage: 'url(' + hot.photoImage + ')',
                        }"
                      ></div>
                    </div>
                  </div>
                  <div class="album-photo-count">
                    <span>{{ hot.sgL_PG_CPhotoQuantityF }}</span>
                  </div>
                </div>
                <div class="album-info">
                  <span class="album-title">{{ hot.sgL_PG_CName }}</span>
                </div>
              </router-link>
            </li>
          </ul>
        </div>
      </section>
      <section class="m-event section-block" v-if="EventList.length > 0">
        <div class="section-title">
           {{ $t('Index.eventList') }}<a href="/eventList" class="section-more">  {{ $t('Index.more') }} </a>
        </div>
        <div class="row">
          <ul class="nearday-event-list flx-li">
            <li v-for="(hot, index) in EventList" :key="hot.id">
              <router-link
                :title="hot.sgL_Title"
                class="items-center"
                :to="{
                  path: `/eventview/${hot.id}`,
                }"
              >
                <div class="event-info">
                  <span class="event-date mr-2">{{
                    hot.sgL_ActivityDateF
                  }}</span>
                  <span class="event-title">{{ hot.sgL_Title }}</span>
                </div>
              </router-link>
            </li>
          </ul>
        </div>
      </section>
      <section class="m-article section-block" v-if="HotList.length > 0">
        <div class="section-title">
           {{ $t('Index.HotList') }} <a href="/articleList" class="section-more">  {{ $t('Index.more') }} </a>
        </div>
        <ul class="m-article-list">
          <li v-for="(hot, index) in HotList" :key="hot.id" class="m-list-item">
            <router-link
              :title="hot.sgL_Title"
              class="flex"
              :to="{
                path: `/articleview`,
                query: { id: hot.id },
              }"
            >
              <div class="m-thumbnail">
                <div class="m-responsive">
                  <div class="m-sizer">
                    <div
                      class="m-image"
                      :style="{
                        backgroundImage: 'url(' + `${hot.sgL_ImageUrl}` + ')',
                      }"
                    ></div>
                  </div>
                </div>
              </div>
              <div class="article-info">
                <span class="article-title"> {{ hot.sgL_Title }} </span>
              </div>
            </router-link>
          </li>
        </ul>
      </section>
    </div>
    <!-- /.流動版介面 -->

    <div id="home" class="container">
      <section>
        <div class="row">
          <div class="col-lg-12 pr-lg-4">
            <!-- 直接false了短片 --> 
            <!-- 打開 -->
            <div
              class="short-video section-group"
              v-if="CloudList.length > 0 "
            >
              <h2 class="section-title">
                 {{ $t('Index.FeedCloud') }}
                <a href="/feed/FeedCloud" class="section-more">  {{ $t('Index.more') }} </a>
              </h2>
              <div class="row">
                <div class="pool-fm row">
                  <singleVideoVue
                    class="pool-cloud fm-set col-12 col-md-3"
                    v-for="item in CloudList"
                    :key="item.id"
                    :id="item.id"
                    :url="item.fileShareUrl"
                    :avatar="item.userLogoBig"
                    :authorName="item.sgL_MyVideoName"
                    :displayName="item.sgL_UsersName"
                    :date="item.sgL_PG_CAddTimerI"
                    :lookCount="item.sgL_PG_CTotalView"
                    :title="item.sgL_Title"
                    :likeCount="item.sgL_PG_CTotalLike"
                    :poster="item.sgL_ImageTempURL"
                    :showViewData="false"
                    :showDetail="false"
                    @like="likeFunc(item)"
                    :item="item"
                  >
                    <template v-slot:SpecifyMenu>
                      <moreMenuVue @ck="copyLink(item.id)">
                        <template v-slot:icon>
                          <i class="fa fa-clone mr-1"></i>
                        </template>
                        <template v-slot:txt>  {{ $t('Index.Copylinks') }} </template>
                      </moreMenuVue>
                      <moreMenuVue @ck="collectFunc(item)">
                        <template v-slot:icon>
                          <i
                            v-if="item.sgL_IsFavorite"
                            class="fas fa-bookmark fa-fw"
                          ></i>
                          <i v-else class="far fa-bookmark mr-1"></i>
                        </template>
                        <template v-slot:txt>  {{ $t('Index.bookmark') }} </template>
                      </moreMenuVue>
                      <moreMenuVue @ck="updateStatistics(item, 50)">
                        <template v-slot:icon>
                          <i class="fa fa-share mr-1"></i>
                        </template>
                        <template v-slot:txt>  {{ $t('Index.share') }} </template>
                      </moreMenuVue>
                      <moreMenuVue @ck="reportFunc(item)">
                        <template v-slot:icon>
                          <i class="far fa-flag mr-1"></i>
                        </template>
                        <template v-slot:txt>  {{ $t('Index.flag') }} </template>
                      </moreMenuVue>
                    </template>
                  </singleVideoVue>
                </div>
              </div>
            </div>
            <div class="hot-video section-group" v-if="featureList.length > 0">
              <h2 class="section-title">
                 {{ $t('Index.SelectedFilms') }} <a href="/videoList" class="section-more">  {{ $t('Index.more') }} </a>
              </h2>
              <div class="row">
                <div
                  class="col-12 col-md-3"
                  v-for="Featured in featureList"
                  v-bind:key="Featured.id"
                >
                  <div class="video-card card">
                    <a
                      :href="`${base.evi}/videowatch/${Featured.sgL_Mov_Vid}/video`"
                    >
                      <div class="video-block">
                        <div class="video-thumbnail">
                          <div class="video-responsive">
                            <div class="video-sizer">
                              <div
                                class="video-image"
                                :style="{
                                  backgroundImage:
                                    'url(' + `${Featured.imageFileP}` + ')',
                                }"
                              ></div>
                            </div>
                          </div>
                          <div class="video-duration">
                            <span>{{ Featured.mov_VSourceTimeFormat }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="video-info p-3">
                        <div
                          class="video-title mb-2"
                          :title="Featured.sgL_Mov_VSubject"
                        >
                          {{ Featured.sgL_Mov_VSubject }}
                        </div>
                        <span class="video-user">{{
                          Featured.sgL_Mem_DisplayName
                        }}</span>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="hot-album section-group" v-if="albumHotList.length > 0">
              <h2 class="section-title">
                 {{ $t('Index.albumList') }} <a href="/albumList" class="section-more">  {{ $t('Index.more') }} </a>
              </h2>
              <div class="row">
                <div
                  class="col-6 col-md-3"
                  v-for="hot in albumHotList"
                  v-bind:key="hot.id"
                >
                  <div class="album-card card">
                    <router-link
                      :title="hot.sgL_PG_CName"
                      class="items-center"
                      :to="{
                        name: 'albumviewPhotostream',
                        query: { id: hot.id },
                      }"
                    >
                      <div class="album-block">
                        <div class="album-thumbnail">
                          <div class="album-responsive">
                            <div class="album-sizer">
                              <div
                                class="album-image"
                                :style="{
                                  backgroundImage:
                                    'url(' + hot.photoImage + ')',
                                }"
                              ></div>
                            </div>
                          </div>
                          <div class="album-photo-count">
                            <span>{{ hot.sgL_PG_CPhotoQuantityF }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="album-info p-3">
                        <div class="album-title mb-2" :title="hot.sgL_PG_CName">
                          {{ hot.sgL_PG_CName }}
                        </div>
                        <span class="album-user">{{
                          hot.sgL_Mem_DisplayName
                        }}</span>
                        <span class="album-upload-date">{{
                          hot.sgL_PG_CAddTimerF
                        }}</span>
                      </div>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
            <div class="hot-article section-group" v-if="HotList.length > 0">
              <h2 class="section-title">
                 {{ $t('Index.articleList') }} <a href="/articleList" class="section-more">  {{ $t('Index.more') }} </a>
              </h2>
              <div class="row">
                <div
                  class="col-12 col-md-3"
                  v-for="(hot, index) in HotList"
                  :key="hot.id"
                >
                  <div class="article-card card">
                    <router-link
                      v-bind:to="{
                        name: 'articleview',
                        query: {
                          id: hot.id,
                        },
                      }"
                    >
                      <div class="article-block">
                        <div class="article-thumbnail">
                          <div class="article-responsive">
                            <div class="article-sizer">
                              <div
                                class="article-image"
                                :style="{
                                  backgroundImage:
                                    'url(' + `${hot.sgL_ImageUrl}` + ')',
                                }"
                              ></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="article-info p-3">
                        <div class="article-title mb-2" :title="hot.sgL_Title">
                          {{ hot.sgL_Title }}
                        </div>
                        <span class="article-category">{{
                          hot.sgL_MasterSortF
                        }}</span>
                        <span class="article-upload-date">{{
                          hot.sgL_CreateTimeE
                        }}</span>
                      </div>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3" v-if="EventList.length > 0">
            <!-- 活動 -->
            <div class="hot-event section-group">
              <h2 class="section-title">
                 {{ $t('Index.eventList') }}
                <a href="/eventList" class="section-more">  {{ $t('Index.more') }} </a>
              </h2>
              <div class="row">
                <div class="col-12">
                  <ul class="nearday-event-list card p-3">
                    <li
                      onclick="javascript:void(0);"
                      v-for="(hot, index) in EventList"
                      :key="hot.id"
                    >
                      <router-link
                        :title="hot.sgL_Title"
                        class="items-center"
                        :to="{
                          path: `/eventview/${hot.id}`,
                        }"
                      >
                        <div class="event-title my-1">
                          <a :title="hot.sgL_Title"> {{ hot.sgL_Title }} </a>
                        </div>
                        <div class="event-info">
                          <span class="event-date mr-4">{{
                            hot.sgL_ActivityDatesF
                          }}</span>
                          <span class="event-region">{{ hot.sgL_CityF }}</span>
                        </div>
                      </router-link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <!-- ./活動 -->

            <!-- 廣告 -->
            <div class="ad section-group">
              <div class="row">
                <div class="col-12">
                  <ins
                    class="adsbygoogle"
                    style="display: inline-block; width: 300px; height: 600px"
                    data-ad-client="ca-pub-8370308321819212"
                    data-ad-slot="7350126089"
                  ></ins>
                </div>
              </div>
            </div>
            <!-- 廣告 -->
          </div>
        </div>
      </section>
    </div>
    <ReportVue ref="report"></ReportVue>
  </div>
</template>
<script>
import pagination from "./common/Page";
import bases from "../api/httpApi/base";
import "../../static/desktop/bootstrap.bundle.min.js"; //外部js必须放到static目录，不然会被打包找不到
import singleVideoVue from "./Social/singleVideo.vue";
import moreMenuVue from "./Social/moreMenu.vue";
import socialTool from "../assets/js/socialJs/tool";
import ReportVue from "./common/Report.vue";
import bannerVue from "./banner.vue";
import M1Vue from "./Ad/M1.vue";

export default {
  name: "Index",
  components: {
    singleVideoVue,
    moreMenuVue,
    ReportVue,
    bannerVue,
    M1Vue,
  },
  data() {
    return {
      featureList: [],
      albumHotList: [],
      CloudList: [],
      HotList: [],
      bannerList: [],
      EventList: [
        // {
        //   sgL_Title: "紅薔薇超馬",
        //   sgL_TypeId: "35",
        //   sgL_TypeIds: [35],
        //   sgL_TypeF: ["長跑"],
        //   isCollection: false,
        //   sgL_ActivityDateF: "08/29(日)",
        //   sgL_ActivityDatesF: "2021/08/29",
        //   isFuture: false,
        //   sgL_ActivityDatesZ: "2021/08/29",
        //   sgL_ActivityDate: "2021-08-29T00:00:00",
        //   sgL_EndActivityDate: "2021-08-29T00:00:00",
        //   sgL_EndActivityDateF: "2021/08/29",
        //   sgL_ActivityDateA: ["2021/08/29", "2021/08/29"],
        //   sgL_AreaId: 46,
        //   sgL_AreaF: "台灣",
        //   sgL_CityId: 10166,
        //   sgL_CityF: "新竹縣",
        //   sgL_Address: null,
        //   sgL_Status: 10200,
        //   sgL_StatusF: "已完結",
        //   sgL_KMKeyworld: "",
        //   sgL_KMKeyworldF: null,
        //   sgL_UnitTitle: null,
        //   sglActivityUrl: null,
        //   sglActivityUrl2: null,
        //   sgL_NotesId: "",
        //   sgL_NotesIds: null,
        //   sgL_NotesName: null,
        //   sgL_KeysWord: "",
        //   sgL_KeysWordF: null,
        //   sgL_ApplyDate: "2021-04-30T00:00:00",
        //   sgL_ApplyDateF: "2021/04/30",
        //   sgL_EndApplyDate: "2021-07-15T00:00:00",
        //   sgL_ApplyDateA: ["2021/04/30", "2021/07/15"],
        //   sgL_EndApplyDateF: "2021/07/15",
        //   sgL_OpenStatus: "Show",
        //   sgL_OpenStatusF: "顯示",
        //   sgL_RView: 133,
        //   sgL_RViewF: "133",
        //   sgL_Praise: 0,
        //   sgL_PraiseF: "0",
        //   sgL_Message: 0,
        //   sgL_MessageF: "0",
        //   sgL_Favorite: 0,
        //   sgL_FavoriteF: "0",
        //   sgL_Share: 0,
        //   sgL_ShareF: "0",
        //   sgL_Recommend: false,
        //   sgL_ActivityDateSection: "2021-8",
        //   sgL_UpdateTime: "2020-09-04T09:45:15",
        //   sgL_UpdateTimeF: "2021/05/26",
        //   sgL_UpdateTimeE: "2021/05/26",
        //   sgL_UpdateTimeS: "2021-05-26 09:22:44",
        //   sgL_UpdateTimeM: "2021-05-26 09:22",
        //   sgL_CreateTime: "2021-05-26T09:22:44.987",
        //   sgL_CreateTimeF: "2021/05/26",
        //   sgL_CreateTimeS: "2021-05-26 09:22:44",
        //   sgL_CreateTimeM: "2021-05-26 09:22",
        //   sgL_CreateTimeE: "2021/05/26",
        //   sgL_IsDel: false,
        //   sgL_UpdateName: "ROMAN",
        //   sgL_CreateName: "ROMAN",
        //   id: 6665,
        // },
        // {
        //   sgL_Title: "Waiao Trail 2021 外澳越野挑戰賽",
        //   sgL_TypeId: "35",
        //   sgL_TypeIds: [35],
        //   sgL_TypeF: ["長跑"],
        //   isCollection: false,
        //   sgL_ActivityDateF: "08/29(日)",
        //   sgL_ActivityDatesF: "2021/08/29",
        //   isFuture: false,
        //   sgL_ActivityDatesZ: "2021/08/29",
        //   sgL_ActivityDate: "2021-08-29T00:00:00",
        //   sgL_EndActivityDate: "2021-08-29T00:00:00",
        //   sgL_EndActivityDateF: "2021/08/29",
        //   sgL_ActivityDateA: ["2021/08/29", "2021/08/29"],
        //   sgL_AreaId: 46,
        //   sgL_AreaF: "台灣",
        //   sgL_CityId: 10173,
        //   sgL_CityF: "宜蘭縣",
        //   sgL_Address: null,
        //   sgL_Status: 10200,
        //   sgL_StatusF: "已完結",
        //   sgL_KMKeyworld: "",
        //   sgL_KMKeyworldF: null,
        //   sgL_UnitTitle: null,
        //   sglActivityUrl: null,
        //   sglActivityUrl2: null,
        //   sgL_NotesId: "",
        //   sgL_NotesIds: null,
        //   sgL_NotesName: null,
        //   sgL_KeysWord: "",
        //   sgL_KeysWordF: null,
        //   sgL_ApplyDate: "2021-05-18T00:00:00",
        //   sgL_ApplyDateF: "2021/05/18",
        //   sgL_EndApplyDate: "2021-06-30T00:00:00",
        //   sgL_ApplyDateA: ["2021/05/18", "2021/06/30"],
        //   sgL_EndApplyDateF: "2021/06/30",
        //   sgL_OpenStatus: "Show",
        //   sgL_OpenStatusF: "顯示",
        //   sgL_RView: 129,
        //   sgL_RViewF: "129",
        //   sgL_Praise: 0,
        //   sgL_PraiseF: "0",
        //   sgL_Message: 0,
        //   sgL_MessageF: "0",
        //   sgL_Favorite: 0,
        //   sgL_FavoriteF: "0",
        //   sgL_Share: 0,
        //   sgL_ShareF: "0",
        //   sgL_Recommend: false,
        //   sgL_ActivityDateSection: "2021-8",
        //   sgL_UpdateTime: "2020-09-04T09:45:15",
        //   sgL_UpdateTimeF: "2021/05/26",
        //   sgL_UpdateTimeE: "2021/05/26",
        //   sgL_UpdateTimeS: "2021-05-26 09:12:02",
        //   sgL_UpdateTimeM: "2021-05-26 09:12",
        //   sgL_CreateTime: "2021-05-26T09:12:02.887",
        //   sgL_CreateTimeF: "2021/05/26",
        //   sgL_CreateTimeS: "2021-05-26 09:12:02",
        //   sgL_CreateTimeM: "2021-05-26 09:12",
        //   sgL_CreateTimeE: "2021/05/26",
        //   sgL_IsDel: false,
        //   sgL_UpdateName: "ROMAN",
        //   sgL_CreateName: "ROMAN",
        //   id: 6658,
        // },
      ],
      base: null,
    };
  },
  beforeMount() {},
  mounted() {},
  created() {
    this.base = bases;
    this.$store.dispatch("updateCurrentIndex", 0);
    this.GetCloudList();
    this.GetFeatureList();
    this.getHotWeek();
    this.getHotList();
    this.getBannerList();
    this.getEventList();
    //this.InitBanner();
  },
  methods: {
    likeFunc(item) {
      if (this.CheckUserIsLogin()) {
        socialTool.addfavorite(1, item, !item.sgL_IsLike);
      }
    },
    reportFunc(item) {
      if (this.CheckUserIsLogin()) {
        socialTool.reportFunc.call(this, item);
      }
    },
    collectFunc(item) {
      if (this.CheckUserIsLogin()) {
        socialTool.addfavorite(0, item);
      }
    },
    copyLink(id) {
      this.copyToClipboard(socialTool.copyLink(id), true);
    },
    updateStatistics(item, type) {
      socialTool.updateStatistics(item, type);
    },
    GetCloudList() {
      let params = {
        SGL_IsShow: 1,
        SGL_Type: 0,
        SkipCount: 0,
        MaxResultCount: 4,
      };
      this.$api.social.GetSocialData(params).then((res) => {
        if (res.data.success) {
          this.CloudList = res.data.result.items;
          // console.log(this.CloudList);
        } else {
          this.$message({ type: "error", message: res.data.error.message });
        }
      });
    },
    InitBanner() {
      $(".carousel-item", ".show-neighbors")
        .each(function () {
          var next = $(this).next();
          if (!next.length) {
            next = $(this).siblings(":first");
          }
          next.children(":first-child").clone().appendTo($(this));
        })
        .each(function () {
          var prev = $(this).prev();
          if (!prev.length) {
            prev = $(this).siblings(":last");
          }
          prev.children(":nth-last-child(2)").clone().prependTo($(this));
        });
      $(".carousel").carousel();
    },
    getEventList() {
      let params = {
        sgL_PhotoId: 0, //后台证明查询大于0的查询全部
        MaxResultCount: 100,
      };
      this.$api.EventApi.getIndexActivieyList(params).then((res) => {
        if (res.data.success) {
          this.EventList = res.data.result;
        }
      });
    },
    getHotList() {
      let params = {
        Sorting: "QueriesCount",
        MaxResultCount: 4,
      };
      this.$api.TopicApi.GetArticleListDesk(params).then((res) => {
        if (res.data.success) {
          this.HotList = res.data.result.items;
        }
      });
    },
    async GetFeatureList() {
      let params = {
        SGL_IsShow: 1,
        SkipCount: 0,
        MaxResultCount: 4,
      };
      this.$api.VideoApi.GetExquisite(params).then((res) => {
        this.featureList = res.data.result.items;
      });
    },
    getHotWeek() {
      var today = new Date();

      var end = this.$api.commons.format(today, "YYYY-MM-DD");

      var oneday = 1000 * 60 * 60 * 24;

      var begindate = new Date(today - oneday * 7);

      var begin = this.$api.commons.format(begindate, "YYYY-MM-DD");

      let params = {
        SGL_AddTimerDate: [begin, end],
        SGL_PG_CPublicshare: true,
        SkipCount: 0,
        Sorting: "QueriesCount",
        MaxResultCount: 4,
      };
      this.$api.albumApi.GetalbumHotWeek(params).then((res) => {
        if (res.data.success) {
          this.albumHotList = res.data.result.items;
        }
      });
    },
    getBannerList() {
      let params = {
        SGL_Type: "M1",
      };
      this.$api.BannerApi.getBanner(params).then((res) => {
        if (res.data.success) {
          this.bannerList = res.data.result.items;
        }
      });
    },
  },
};
</script>

<style scoped>
.flx-li {
  flex: 1;
}
.event-title {
  color: black;
}
.m-list-item {
  padding-right: 5px;
}
.left5 {
  padding-right: 5px;
}
.pool-cloud {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/Index.vue